module.exports = __webpack_public_path__ + "media/images/graph-c709839bb70a39a33f2809a9442b712a.png";